"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NanotechIndustries = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const CardRenderer_1 = require("../render/CardRenderer");
const ResourceType_1 = require("../../ResourceType");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const AddResourcesToCard_1 = require("../../deferredActions/AddResourcesToCard");
const MoonCards_1 = require("../../moon/MoonCards");
const Card_1 = require("../Card");
const Size_1 = require("../render/Size");
class NanotechIndustries extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.NANOTECH_INDUSTRIES,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.MOON],
            startingMegaCredits: 42,
            resourceType: ResourceType_1.ResourceType.SCIENCE,
            initialActionText: 'Draw 3 cards and keep 2.',
            metadata: {
                cardNumber: 'MC1',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br;
                    b.megacredits(42).cards(2).discardedCards(1).asterix();
                    b.corpBox('action', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.action('Add 1 science resource to ANY card, except those giving 2 or more VP per resource.', (eb) => {
                            eb.empty().startAction.science(1).asterix();
                        });
                        ce.vSpace(Size_1.Size.LARGE);
                    });
                    b.vpText('1 VP per 2 science resources here.');
                }),
                description: 'You start with 42 M€. As your first action, draw 3 cards. Keep 2 and discard the rest.',
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.science(1, 2),
            },
        });
        this.resourceCount = 0;
    }
    play() {
        return undefined;
    }
    initialAction(player) {
        return player.drawCardKeepSome(3, { keepMax: 2 });
    }
    canAct() {
        return true;
    }
    action(player) {
        player.game.defer(new AddResourcesToCard_1.AddResourcesToCard(player, ResourceType_1.ResourceType.SCIENCE, { filter: (card) => MoonCards_1.MoonCards.scienceCardsWithLessThan2VP.has(card.name) }));
        return undefined;
    }
    getVictoryPoints() {
        return Math.floor(this.resourceCount / 2);
    }
}
exports.NanotechIndustries = NanotechIndustries;
//# sourceMappingURL=NanotechIndustries.js.map